<!-- <!-- Fully updated Angular template for Country component
     - Adds a per-tile delete button
     - Uses existing modal markup (show/hide controlled via display/displayDelete)
     - Assumes component has properties: adminName, searchval, onChangeEvent, reset,
       openAdd, showData, allCountry, editCountry, display, showAdd, showEdit,
       countryForm, error_messages, addCountry, updateCountry, displayDelete,
       confirmDelete (or delete modal is opened by setting selectedDeleteId + displayDelete),
       onCloseHandled, delete, showNodata
-->

<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">Country</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36" height="36" style="margin-left: 0.5em;" src="assets/tenant-avatar.jpg" class="rounded-circle" alt="admin" />
          </div>
        </div>

        <!-- Search + Add on same line -->
        <div class="row my-4 align-items-center">
          <!-- Search wrapper -->
          <div class="col-md-4">
            <div class="search-wrapper position-relative">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>

              <input
                type="text"
                class="search-input form-control"
                placeholder="Search Country"
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
                aria-label="Search"
              />

              <button
                *ngIf="searchval"
                class="clear-btn btn btn-sm"
                type="button"
                (click)="reset()"
                aria-label="Clear search"
                title="Clear"
              >
                ✕
              </button>
            </div>
          </div>

          <!-- Spacer for layout -->
          <div class="col-md-4"></div>

          <!-- Add Country button aligned right -->
          <div class="col-md-4 text-right">
            <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add Country
            </button>
          </div>
        </div>

        <!-- Cards / Grid -->
        <div class="row" *ngIf="showData">
          <div class="col-md-3 degreeContent position-relative mb-3" *ngFor="let country of allCountry">
            <div class="card h-100 p-3">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <p class="mb-1 country-name">{{ country.country }}</p>
                </div>

                <div class="d-flex align-items-center">
                  <!-- Edit icon -->
                  <button class="btn btn-sm btn-outline-secondary mr-2" (click)="editCountry(country)" aria-label="Edit country" title="Edit">
                    <i class="fa fa-pencil"></i>
                  </button>

                  <!-- Delete button (per-tile) -->
                  <button
                    class="btn btn-sm btn-outline-danger"
                    (click)="confirmDelete(country)"
                    aria-label="Delete country"
                    title="Delete"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- No Data -->
        <div class="noData text-center" *ngIf="showNodata">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>

      <!-- Add/Edit Modal -->
      <div class="backdrop" [ngStyle]="{'display':display}"></div>
      <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-between align-items-center" *ngIf="showAdd || showEdit">
              <h5 class="modal-title">{{ showAdd ? 'Add Country' : 'Edit Country' }}</h5>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <form [formGroup]="countryForm" (ngSubmit)="showAdd ? addCountry() : updateCountry()">
                <div class="form-group">
                  <label for="countryName">Country</label>
                  <input id="countryName" type="text" class="form-control" formControlName="countryName" [(ngModel)]="country" />
                  <div class="error-messages mt-1">
                    <div *ngFor="let error of error_messages.countryName">
                      <div
                        class="error-message text-danger small"
                        *ngIf="countryForm.get('countryName').hasError(error.type) && (countryForm.get('countryName').dirty || countryForm.get('countryName').touched)"
                      >
                        {{ error.message }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-right mt-3">
                  <button type="submit" class="btn btn-primary" [disabled]="!countryForm.valid">{{ showAdd ? 'Add Country' : 'Update' }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
      <div class="modal" id="deleteModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm Delete</h5>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <p>Do you want to delete Country?</p>

              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-success mr-2" (click)="delete()" style="width: 20%">Yes</button>
                <button type="button" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%; margin-left: 0.3em;">No</button>
              </div>

              <br />
              <p class="error text-danger" *ngIf="showErr">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
